import React from 'react';
import clsx from 'clsx';

const Item = ({ className, name, status }) => {
    return (
        <div className={clsx('balance-analysis-box__data-item', className)}>
            <p>{name ?? ''}</p>
            <p>{status ?? '沒有數據'}</p>
        </div>
    );
};

const BalanceAnalysisBox = ({ data = {}}) => {
    const defaultItems = [
        { key: 'upperBody', className: 'upper-body' },
        { key: 'lowerBody', className: 'lower-body' },
        { key: 'trunk',     className: 'trunk' },
    ];

    const balancedImage = data?.balancedImageName || null;

    return (
        <div className={'balance-analysis-box'}>
            {balancedImage && <img className={'balance-analysis-box__img'} src={balancedImage} alt={"inbody"} />}
            <div className={'balance-analysis-box__content'}>
                {defaultItems.map(({ key, className }) => {
                    return <Item key={key} className={className} name={data[key]?.name} status={data[key]?.status} />;
                })}
            </div>
        </div>
    );
};

export default BalanceAnalysisBox;
